<div class="card bg-2">
  <div class="card-body">
    <mat-horizontal-stepper class="bg-2 form-group row" #stepper>
      <mat-step label="Seleção grupo de carteira">
        <selecao-grupo-carteira #selecaoGrupoCarteiraComponent (onGrupoCarteiraChange)="updateGrupoCarteria($event)"></selecao-grupo-carteira>
      </mat-step>
      <mat-step label="Seleção carteiras">
        <selecao-carteira #selecaoCarteiraComponent (onCarteiraChange)="updateCarteira($event)"></selecao-carteira>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
<div class="card mb-4 mt-1 bg-2">
  <div class="card-footer">
    <div class="d-flex flex-row justify-content-end">
      <div class="">
        <button mat-raised-button color="primary" title="Gravar" aria-label="left" (click)="doneStepper()"
                [disabled]="isDisabled">
          <loading-icon [btnLabel]="'Gravar'" [loading]="loading$ | async"></loading-icon>
        </button>
      </div>
    </div>
  </div>
</div>
